import { Link } from 'react-router-dom';

/** Stands in for a Documents-tab document's thread on its questionnaire card: the conversation lives in Documents. */
export function DocumentsTabLinkStrip({
  variant = 'reviewer_commented',
}: {
  /** 'reviewer_commented' = PR #115 copy; 'newer_comments' = "Newer comments on this document are in Documents." + "Open →". */
  variant?: 'reviewer_commented' | 'newer_comments';
}) {
  const newer = variant === 'newer_comments';
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 text-sm text-slate-600">
      <span>
        {newer
          ? 'Newer comments on this document are in Documents.'
          : 'The reviewer left a comment on this document.'}
      </span>
      <Link to="/documents" className="font-medium text-[#4D148C] underline hover:text-[#3B0F6B]">
        {newer ? 'Open →' : 'Open in Documents →'}
      </Link>
    </div>
  );
}
